import { useContext } from 'react';

import AbsoluteBgImageDark from '../../assets/images/register/register-bg-dark.jpg';
import AbsoluteBgImage from '../../assets/images/register/register-bg.png';
import ThemeContext from '../../contexts/theme-context/ThemeContext';

import RegisterCredentials from './components/Register';

/**
 * Register page
 */
function Register() {
  const { theme } = useContext(ThemeContext);
  /**
   * getBgImage
   */
  const getBgImage = () => {
    return theme === 'light' ? AbsoluteBgImage : AbsoluteBgImageDark;
  };
  return (
    <div className="register-wrap">
      <RegisterCredentials />;
      <img src={getBgImage()} alt="" className="absolute-bg-image" />
    </div>
  );
}

export default Register;
